var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:`tf-table-td ${_vm.column.prop
    ? `cell-prop-${_vm.column.prop}`
    : ''}`},[_vm._t("default",function(){return [(_vm.rowData[_vm.column.prop])?[_vm._v("\n      "+_vm._s(_vm.rowData[_vm.column.prop])+"\n    ")]:_vm._t("emptyCell",function(){return [_vm._v("\n      —\n    ")]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }